<template>
  <el-row type="flex" justify="center" align="middle" style="height: 100vh">
    <el-col style="width:400px">
      <el-card shadow="never">
        <div slot="header" class="clearfix">
          <span>Forgot Password</span>
          <router-link style="float: right; text-decoration:none;" to="/signin">Sign-in</router-link>
        </div>
        <div>
          <el-form :model="ruleForm" ref="ruleForm" :rules="rules">
            <el-form-item prop="email" label="Email" size="medium">
              <el-input type="email" placeholder="Enter Email" v-model="ruleForm.email"></el-input>
            </el-form-item>
            <el-form-item size="medium">
              <el-button type="primary" :loading="loading" :disabled="loading" @click="submitForm('ruleForm')">Submit</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
    data: () => ({
      ruleForm: {
        email: ''
      },
      rules: {
        email: [
          { required: true, message: 'Please input email address', trigger: 'blur' },
          { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
        ]
      },
      loading: false
    }),
    methods: {
      submitForm(formName){
        this.$refs[formName].validate(valid => {
          if(valid){
            this.loading = true;
            this.$http.post('/forgot', JSON.stringify({ email: this.ruleForm.email }))
            .then(response => {
              this.$message({
                message: response.data.msg,
                type: 'success',
                duration: 5000
              });
            })
            .catch(error => {
              this.$message({
                message: error.data.msg,
                type: 'error',
                duration: 5000
              });
            })
            .finally(() => {
              this.loading = false
              this.ruleForm.email = ''
            })
          }
        });
      }
    }
}
</script>